var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _TreatmentHistoryChangedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import ConsultationPlannedJournalEvent from "./consultation-planned-journal-event";
import OkChimioSnapshotCapturedJournalEvent from "./ok-chimio-snapshot-captured-journal-event";
import Patient from "./patient";
import Protocol from "./protocol";
import RecursiveTaskPlannedJournalEvent from "./recursive-task-planned-journal-event";
import TaskPlannedJournalEvent from "./task-planned-journal-event";
//---- Automatically generated, don't update this part ----
let TreatmentHistoryChangedJournalEvent = (_dec = belongsTo("patient", {
  async: false,
  inverse: "treatmentHistoryChangedJournalEvent"
}), _dec2 = hasMany("task-planned-journal-event", {
  async: false,
  inverse: "treatmentHistoryChangedJournalEvent"
}), _dec3 = hasMany("recursive-task-planned-journal-event", {
  async: false,
  inverse: "treatmentHistoryChangedJournalEvent"
}), _dec4 = hasMany("consultation-planned-journal-event", {
  async: false,
  inverse: "treatmentHistoryChangedJournalEvent"
}), _dec5 = hasMany("ok-chimio-snapshot-captured-journal-event", {
  async: false,
  inverse: "treatmentHistoryChangedJournalEvent"
}), _dec6 = attr("surgery-surgeries"), _dec7 = attr("protocols"), _dec8 = attr("chemotherapies"), _dec9 = attr("oncologies"), _dec10 = attr("radiotherapies"), _dec11 = attr("immunotherapies"), _dec12 = attr("targeted-therapies"), _dec13 = attr("hormonotherapies"), _dec14 = attr("other-follow-up-events"), _class = (_TreatmentHistoryChangedJournalEvent = class TreatmentHistoryChangedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor, this);
    _initializerDefineProperty(this, "taskPlannedJournalEvents", _descriptor2, this);
    _initializerDefineProperty(this, "recursiveTaskPlannedJournalEvents", _descriptor3, this);
    _initializerDefineProperty(this, "consultationPlannedJournalEvents", _descriptor4, this);
    _initializerDefineProperty(this, "okChimioSnapshotCapturedJournalEvents", _descriptor5, this);
    _initializerDefineProperty(this, "surgerySurgeries", _descriptor6, this);
    _initializerDefineProperty(this, "protocols", _descriptor7, this);
    _initializerDefineProperty(this, "chemotherapies", _descriptor8, this);
    _initializerDefineProperty(this, "oncologies", _descriptor9, this);
    _initializerDefineProperty(this, "radiotherapies", _descriptor10, this);
    _initializerDefineProperty(this, "immunotherapies", _descriptor11, this);
    _initializerDefineProperty(this, "targetedTherapies", _descriptor12, this);
    _initializerDefineProperty(this, "hormonotherapies", _descriptor13, this);
    _initializerDefineProperty(this, "otherFollowUpEvents", _descriptor14, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.treatment-history-changed-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })]
    };
  }
  get surgery() {
    return this.surgerySurgeries !== undefined && this.surgerySurgeries.length > 0;
  }
  get lastSurgery() {
    return this.lastElement(this.surgerySurgeries, "startDate");
  }
  get chemotherapy() {
    return this.chemotherapies !== undefined && this.chemotherapies.length > 0;
  }
  get lastChemotherapy() {
    return this.lastElement(this.chemotherapies, "therapyOne");
  }
  get oncology() {
    return this.oncologies !== undefined && this.oncologies.length > 0;
  }
  get radiotherapy() {
    return this.radiotherapies !== undefined && this.radiotherapies.length > 0;
  }
  get lastRadiotherapy() {
    return this.lastElement(this.radiotherapies, "startDate");
  }
  get hasImmunotherapy() {
    return this.immunotherapies !== undefined && this.immunotherapies.length > 0;
  }
  get lastImmunotherapy() {
    return this.lastElement(this.immunotherapies, "startDate");
  }
  get targetedTherapy() {
    return this.targetedTherapies !== undefined && this.targetedTherapies.length > 0;
  }
  get lastTargetedtherapy() {
    return this.lastElement(this.targetedTherapies, "startDate");
  }
  get hormonotherapy() {
    return this.hormonotherapies !== undefined && this.hormonotherapies.length > 0;
  }
  get lastHormonotherapy() {
    return this.lastElement(this.hormonotherapies, "startDate");
  }
  get otherFollowUp() {
    return this.otherFollowUpEvents !== undefined && this.otherFollowUpEvents.length > 0;
  }

  /*
   * Remove every task and consultations associated to this JE from the store (without a push to the API) before fetching them
   */
  async clearAndFetchAssociatedTaskAndConsultation() {
    // In fact, the back will not push archived JEs
    while (this.taskPlannedJournalEvents.length > 0) {
      this.taskPlannedJournalEvents[0].unloadRecord();
    }
    while (this.consultationPlannedJournalEvents.length > 0) {
      this.consultationPlannedJournalEvents[0].unloadRecord();
    }
    while (this.recursiveTaskPlannedJournalEvents.length > 0) {
      this.recursiveTaskPlannedJournalEvents[0].unloadRecord();
    }
    await this.store.query("treatment-history-changed-journal-event", {
      filter: {
        id: this.id
      },
      include: ["task-planned-journal-events", "task-planned-journal-events.task-processed-journal-event", "recursive-task-planned-journal-events", "consultation-planned-journal-events"].join(",")
    });
  }
  get activeProtocols() {
    return this.protocols.filter(p => p.isActive);
  }
  get pausedProtocols() {
    return this.protocols.filter(p => p.isPaused);
  }
  get pausedAndActiveProtocols() {
    return this.protocols.filter(p => p.isActive || p.isPaused);
  }
  get nextProtocol() {
    const today = dayjs();
    let nextProtocol;
    let nextCureDiff = Infinity;
    this.protocols.filter(p => p.treatmentProtocolType == "cure").forEach(p => {
      const nextCureDate = p.nextCureDate;
      if (!nextCureDate) return;
      const diff = dayjs(nextCureDate).diff(today);
      if (diff < nextCureDiff) {
        nextProtocol = p;
        nextCureDiff = diff;
      }
    });
    return nextProtocol;
  }
  getProtocol(protocolUuid) {
    if (!protocolUuid) return undefined;
    return this.protocols.find(protocol => protocol.uuid == protocolUuid);
  }
  get specificProtocols() {
    return this.protocols.filter(p => !p.isDefaultProtocol);
  }
  get okChimioMustBeValidated() {
    const res = this.specificProtocols.filter(p => {
      const cureKey = p.cureKeyInOkChimioValidationPeriod;
      return cureKey && p.uuid && !this.protocolCureHasSnapshot(p.uuid, cureKey);
    });
    return res;
  }
  protocolCureHasSnapshot(protocolUuid, cureKey) {
    if (!cureKey) return false;
    return Boolean(this.okChimioSnapshotCapturedJournalEvents.find(okChimio => okChimio.protocolUuid == protocolUuid && okChimio.cureKey == cureKey));
  }
  lastElement(array, keyToCompare) {
    return array.sort((a, b) => a[keyToCompare] < b[keyToCompare] ? 1 : -1)[0];
  }
}, _defineProperty(_TreatmentHistoryChangedJournalEvent, "type", "treatment-history-changed-journal-event"), _TreatmentHistoryChangedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "taskPlannedJournalEvents", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "recursiveTaskPlannedJournalEvents", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "consultationPlannedJournalEvents", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "okChimioSnapshotCapturedJournalEvents", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "surgerySurgeries", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "protocols", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "chemotherapies", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "oncologies", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "radiotherapies", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "immunotherapies", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "targetedTherapies", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "hormonotherapies", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "otherFollowUpEvents", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TreatmentHistoryChangedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.